import { IAbExperiment } from '../../types/abUseExperiments';

export function getExperiment(experiments: IAbExperiment[], experimentName: string) {
  return experiments.find(o => o.experimentName === experimentName);
}
